import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cn } from "../../@/lib/utils";
const ProgressBar = React.forwardRef(({ className, isTimer, value = 0, onFinishTimer, ...props }, ref) => {
    const [progressBarValue, setProgressBar] = React.useState(value);
    React.useEffect(() => {
        if (isTimer) {
            const interval = setInterval(() => setProgressBar(progressBarValue - 20), 1000);
            if (progressBarValue == 0) {
                onFinishTimer?.();
                return clearInterval(interval);
            }
        }
    }, [progressBarValue, onFinishTimer]);
    return (_jsx(ProgressPrimitive.Root, { ref: ref, className: cn("relative h-3 w-full overflow-hidden rounded-full bg-blue-100", className), ...props, children: _jsx(ProgressPrimitive.Indicator, { className: "h-full w-full flex-1 bg-blue-500 transition-all", style: { transform: `translateX(-${100 - (progressBarValue || 0)}%)` } }) }));
});
ProgressBar.displayName = ProgressPrimitive.Root.displayName;
export { ProgressBar };
//# sourceMappingURL=ProgressBar.js.map